module.exports = __webpack_public_path__ + "img/sub-cat-self-esteem.6ac34a52.svg";